import { render, staticRenderFns } from "./PeriodRange.vue?vue&type=template&id=1910d42f&"
import script from "./PeriodRange.vue?vue&type=script&lang=js&"
export * from "./PeriodRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports